import { Component, OnInit } from "@angular/core";
import { Message } from "../../Model/System/Message";
import { TestResult } from "../../Model/Dto/TestResult";

import { ModelService } from '../../Services/model.service';
import { SendToNWConfig } from '../../Model/Dto/SendToNWConfig';
import { Customer } from "../../Model/user/Customer";
import { OAuthService } from "angular-oauth2-oidc";



@Component({
  selector: "dscInfos",
  templateUrl: "dscInfos.component.html"
})
export class DscInfosComponent implements OnInit {

  value: any[];
  uploadHeaders: any;
  msg: string = "";

  constructor(public modelService: ModelService, private oAuthService: OAuthService) {
    this.onBeforeSendUpload = this.onBeforeSendUpload.bind(this);
    this.reset();
  }

  reset() {
    this.uploadHeaders = {     
      CustomerId: this.model.id
    }
    this.value = [];
  }

  onBeforeSendUpload(e: { request: XMLHttpRequest }) {
    e.request.withCredentials = true;
    e.request.setRequestHeader('Authorization', 'Bearer ' + this.oAuthService.getAccessToken());
  }

  onUploaded(e) {
   
    this.reset();
    this.modelService.loginService.customerService.getCustomer (this.model.id).subscribe((result: Customer) => {
      this.model = result;
    });
  }

  onUploadStarted(e) {
   
  }


  ngOnInit(): void { 
    if (this.modelService.loginService.currentUser == null) {
      this.modelService.router.navigate(["/"]);
      return;
    } 
  }

  isManager(): boolean {
    if (this.modelService.loginService.currentUser.currentClaim == "USER") return false;
    return true;
    }

   get model(): Customer {
    
        return this.modelService.loginService.currentCustomer;  
    }
  set model(value: Customer) {
    this.modelService.loginService.currentCustomer = value;
    }





  update() {
    this.modelService.loginService.customerService.update(this.model).subscribe((result: Customer) => {
      this.model = result;
    });
  }



 





  get showPlaceHolders() {
    return this.modelService.loginService.showPlaceHolders;
  }


}


